import { KText } from '@/ui-library/components/text';
import { Avatar, Box, Flex, Icon } from '@chakra-ui/react';
import { formatStartAndEndDates } from '@/lib/util';
import { Briefcase01 } from '@kula-ai/icons/outline/Briefcase01';

export const ExperienceView = ({ isEnriched, experience }) => {
  const expLogo = isEnriched ? experience?.logo : experience?.company?.logo;
  const expName = isEnriched ? experience?.company : experience?.company?.name;
  const expRole = isEnriched ? experience?.position : experience?.title;
  const expStart = isEnriched ? experience?.from : experience?.start_date;
  const expEnd = (isEnriched ? experience?.to : experience?.end_date) || null;

  return (
    <Flex gap="12px" py="4px">
      {expLogo ? (
        <Avatar
          width="32px"
          height="32px"
          borderRadius="6px"
          src={expLogo}
          name={expName}
        />
      ) : (
        <Box
          bg="secondary-50"
          borderRadius="6px"
          p="4px"
          width="36px"
          height="36px"
        >
          <Icon as={Briefcase01} color="secondary-700" w="28px" h="20px" />
        </Box>
      )}
      <Flex gap="2px" flexDir="column">
        <KText size="sm-semi-bold">{expName || '-'}</KText>
        <KText size="sm-regular">{expRole || '-'}</KText>
        <KText size="sm-regular">
          {formatStartAndEndDates(expStart, expEnd) || '-'}
        </KText>
      </Flex>
    </Flex>
  );
};
